var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');

var DualRowPackageWithJOrLLeadData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //center to center distance between terminals at opposite sides
    this.terminalCenterToCenterDistance = this.value("terminalCenterToCenterDistance", true);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalCenterToCenterDistance);
};

lib_core.inherit(DualRowPackageWithJOrLLeadData, DualRowPackageData);
lib_core.JsonParser.registerClass(DualRowPackageWithJOrLLeadData, "DualRowPackageWithJOrLLeadData");
module.exports = DualRowPackageWithJOrLLeadData;

DualRowPackageWithJOrLLeadData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["terminalCenterToCenterDistance"] = [this.terminalCenterToCenterDistance];
};
/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
DualRowPackageWithJOrLLeadData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    //update pad size from terminal center to center disance
    self.component.padWidthMax = self.horizontalLeadToLeadSpanMax() - self.terminalCenterToCenterDistance();
    self.component.padWidthMin = self.horizontalLeadToLeadSpanMin() - self.terminalCenterToCenterDistance();
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    //Note: Pad should be calculated in anti-clockwise direction [left, down, right, up] for quad packages and [left and right] for rest of the packages.
    //The order is important to apply proper pad name from the generated namelist. Do not change the order otherwise pad's name would be incorrect.
    var i, nRow = self.component.padsPerSide[0],
        hPitch = self.component.C,
        pinPitch = self.verticalPinPitch(),
        motif = self.getMotif();

    for(i = 0; i < 2 * nRow; i++) {
        var col = Math.floor(i / nRow);
        var row = i % nRow;
        if (col % 2 == 1) row = nRow - 1 - row; // in odd columns change order from bottom to top

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord((-0.5 + col) * hPitch, ((nRow - 1) / 2 - row) * pinPitch));
        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};
